import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {useCanvasFormMetadata} from '../../../../../../util/customHooks';
import BodySpecialAccordionContentListItemRemove from './BodySpecialAccordionContentListItemRemove';
import ProgressBar from '../../../../BaseComponentWrappers/MotifProgressBar';
import {labels} from '../../../../../../util/utils';

export default function BodySpecialAccordionContentListItem({
	id,
	remove,
	removeLabel,
	children,
	className,
	level,
	onRemoveClick,
	isProcessing
}) {
	const {isTargetEngagement} = useCanvasFormMetadata();

	const [showRemove, setShowRemove] = useState(false);
	const handleOnMouseOver = useCallback(() => {
		if (remove) {
			setShowRemove(true);
		}
	}, []);

	const handleOnMouseLeave = useCallback(() => {
		if (remove) {
			setShowRemove(false);
		}
	}, []);

	const handleOnRemoveClick = useCallback((e) => {
		onRemoveClick && onRemoveClick(e);
	}, []);

	const showRemoveComponent = !isTargetEngagement && remove;

	return (
		<StyledBodySpecialAccordionContentListItem
			isProcessing={isProcessing}
			className={className}
			level={level}
			onMouseOver={handleOnMouseOver}
			onMouseLeave={handleOnMouseLeave}
		>
			{isProcessing && (
				<StyledMotifProgressBar className="StyledMotifProgressBar">
					<ProgressBar isIndeterminate showLabel labelComponent={<span>{labels.removingLabel}</span>} />
				</StyledMotifProgressBar>
			)}
			<section className={`gray-fade-container ${isProcessing ? 'grayFadeProcessing' : ''}`}>
				<React.Fragment>
					{children}
					{showRemoveComponent && (
						<BodySpecialAccordionContentListItemRemove
							id={id}
							showRemove={showRemove}
							removeLabel={removeLabel}
							onClick={(e) => handleOnRemoveClick(e)}
							styleName="manageUnassociatedITSPListControlRemoveLink"
						/>
					)}
				</React.Fragment>
			</section>
		</StyledBodySpecialAccordionContentListItem>
	);
}

BodySpecialAccordionContentListItem.propTypes = {
	remove: PropTypes.bool,
	removeLabel: PropTypes.string,
	children: PropTypes.node,
	className: PropTypes.string,
	level: PropTypes.number,
	onRemoveClick: PropTypes.func,
	isProcessing: PropTypes.bool
};

BodySpecialAccordionContentListItem.defaultProps = {
	remove: false,
	className: 'StyledBodySpecialAccordionContentListItem body-special-accordion-content-list-item',
	level: 0
};

const StyledBodySpecialAccordionContentListItem = styled.section`
	border-bottom: var(--px-1) solid var(--neutrals-200);
	margin-left: ${(props) => props.level * 2.5}rem;
	padding: var(--px-10) 0;
	font-weight: bold;
	display: block;
	justify-content: space-between;
	align-items: flex-start;
	max-height: var(--px-450);
	&:last-child {
		border-bottom: none;
	}
	.gray-fade-container {
		width: 100%;
		display: flex;
		${(props) => (props.isProcessing ? 'opacity: 0.3; pointer-events: none;' : '')}
	}
	.manageUnassociatedITSPListControlRemoveLink {
		font-weight: bold;
		font-size: var(--px-14);
		margin: 0 var(--px-10) 0 auto;
		color: var(--blue-600);
		&:hover {
			text-decoration: underline;
		}
	}
`;

const StyledMotifProgressBar = styled.section`
	position: relative;
	.motif-progress-bar-wrapper {
		height: var(--px-24) !important;
		width: var(--px-24) !important;
		position: absolute !important;
		left: 0 !important;
		right: 0 !important;
		margin: 0 auto;
		span {
			color: var(--green-500);
			font-size: var(--px-12);
		}
		.motif-progress {
			background-color: var(--green-500);
		}
	}
`;
